<script>
export default {
  name: "account"
};
</script>

<template>
  <div class="view" id="account">
    <div class="view__bar">
      <div class="container">
        <div class="row">
          <div class="rowColumn">
            <sapp-back />
            <!-- <span>Account</span> -->
            <h2 class="bar__title">Profile</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
